export default __webpack_public_path__ + "static/media/redcliffe.e5251c9d.gif";